<template>
  <div class="field category">
    <span v-if="label"
          class="label text-right"
          :class="labelClass"
    >
      {{ label }}
    </span>

    <div class="value v-align"
         :class="valueClass"
    >
      <fa v-for="n in value"
          :key="n"
          fa-class="star"
      >
      </fa>
    </div>
  </div>
</template>

<script>
import fa from '@/components/global/icon/fontAwesome'

export default {
  components: {
    fa
  },
  props: {
    value: Number,
    label: String,
    width: String
  },
  computed: {
    valueClass: function () {
      if (this.label) {
        return 'col-8'
      }
    },
    labelClass: function () {
      if (this.width === 'large') {
        return 'col-2'
      } else {
        return 'col-4'
      }
    }
  }
}
</script>
